export const shareAppPathForProject = hash => `/projects/shared_view/${hash}`;
export const shareAppPathForFolder = hash => `/folders/shared_view/${hash}`;
